// extracted by mini-css-extract-plugin
export default {"contentHome":"AboutBuildeAi_contentHome__xAO6s","socialLink":"AboutBuildeAi_socialLink__sNEfX","aboutTitle":"AboutBuildeAi_aboutTitle__f43so"};